import { GL_Container, groupsLessonFadeVariants, groupsLessonVariants } from "./GroupsLesson.styled";
import { observer } from "mobx-react";
import { useStores } from "../../../../../../../stores";
import { GroupLessonCell } from "./GroupLessonCell";

type GroupsLessonAnimationMode = "stagger" | "fade";

interface GroupsLessonProps {
	animationMode: GroupsLessonAnimationMode;
}

export const GroupsLesson = observer(({ animationMode }: GroupsLessonProps) => {
	const { grandCharts } = useStores();
	const { selected } = grandCharts;

	const variants = animationMode === "fade" ? groupsLessonFadeVariants : groupsLessonVariants;

	return (
		<GL_Container
			$modulesCount={selected.grand_chart_modules.length}
			variants={variants}
			initial="hidden"
			animate="visible"
			exit="exit"
		>
			{selected.grand_chart_courses.map((grandChartCourseStore) =>
				selected.grand_chart_modules.map((grandChartModuleStore) => {
					const key = `${grandChartCourseStore.id}-${grandChartModuleStore.id}`;
					const grandChartGroupLessonsStore = selected.group_lessons_map[key] || [];

					return (
						<GroupLessonCell
							key={key}
							service={selected.service.slug}
							grandChartGroupLessonsStore={grandChartGroupLessonsStore}
						/>
					);
				}),
			)}
		</GL_Container>
	);
});
